import { IAction } from "./UI.Controls/Actions/IAction";
/**
 * Rozhraní pro komponenty, které podporují vlastnost interactive
 */
export interface IInteractive {
    interactive: boolean;
}

export class IInteractive {
    private static _properties: (keyof IInteractive)[] = ["interactive"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value));
    }
}

/**
 * Rozhraní pro komponenty, které v sobě uchovávají XGAction
 */
export interface IControlWithXGAction {
    xgAction: IAction;
}

export class IControlWithXGAction {
    private static _properties: (keyof IControlWithXGAction)[] = ["xgAction"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value));
    }
}
